<!--Instructions-->
<div class="TopBorder">
	<h4 style="text-align: center">Example Format:</h4>
	<table>
		<tr>
			<th>
				<label> 1 </label>
			</th>
			<th>
				<label> 2 </label>
			</th>
			<th>
				<label> 3 </label>
			</th>
			<th>
				<label> 4 </label>
			</th>
			<th>
				<label> 5 </label>
			</th>
		</tr>
		<tr>
			<th>
				<label> School Number </label>
			</th>
			<th>
				<label> Locker Number </label>
			</th>
			<th>
				<label> Locker Comments </label>
			</th>
			<th>
				<label> Student ID (If being assigned) </label>
			</th>
			<th>
				<label> Combination (If being assigned) </label>
			</th>
		</tr>
		<tr>
			<th>
				<label> ex. 10M45 </label>
			</th>
			<th>
				<label> ex. 123 </label>
			</th>
			<th>
				<label> ex. Good Condition </label>
			</th>
			<th>
				<label> ex. 12345678 </label>
			</th>
			<th>
				<label> ex. 35-2-24 </label>
			</th>
		</tr>
	</table>
</div>

<!--Options-->
<div class="MainGrid">
	<!--School-->
	<label>School:</label>
	<caass-schoolselector
		[Disabled]="IsLoading() == true"
		[ShowAll]="SchoolSelectShowAll"
		[ShowAllID]="SchoolSelectShowAllID"
		[ShowAllText]="SchoolSelectShowAllText"
	>
	</caass-schoolselector>

	<!--Assigned?-->
	<label>Assigned:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="AssignableOptionID" [(ngModel)]="AssignableOptionID">
		<option *ngFor="let o of lstAssignableOption" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>

	<!--Show Student ID-->
	<label>Show Student ID:</label>
	<div class="CheckCenter">
		<input type="checkbox" class="form-control CHK" [disabled]="IsLoading() == true" [(ngModel)]="ShowStudentID" />
	</div>

	<!--Format-->
	<label>Format:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="FormatOptionID" [(ngModel)]="FormatOptionID">
		<option *ngFor="let o of lstFormatOptions" [ngValue]="o.ID">
			{{ o.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onExport()">Export</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
